import React,{useEffect,useRef,useState} from "react";
import {historyState,subscribeHistory,loadOlderHistory} from "./conversationPaging.mjs";
export default function HistoryPagination({storeId,phone,hasMore:explicit,loadMore}){
  const [,refresh]=useState(0),[busy,setBusy]=useState(false),[error,setError]=useState("");
  const button=useRef(null),loading=useRef(false);
  useEffect(()=>subscribeHistory(()=>refresh(n=>n+1)),[]);
  const state=historyState(storeId,phone);
  const hasMore=explicit??(state&&!state.complete);
  const run=async()=>{
    if(loading.current||!hasMore)return;
    const parent=button.current?.parentElement;
    const height=parent?.scrollHeight||0,top=parent?.scrollTop||0;
    loading.current=true;setBusy(true);setError("");
    try{
      const ok=await (loadMore?loadMore():loadOlderHistory(storeId,phone));
      if(ok===false)throw Error();
      requestAnimationFrame(()=>{if(parent)parent.scrollTop=top+parent.scrollHeight-height;});
    }catch{setError("Não foi possível carregar as anteriores. Tente novamente.");}
    finally{loading.current=false;setBusy(false);}
  };
  const runRef=useRef(run);runRef.current=run;
  useEffect(()=>{
    const parent=button.current?.parentElement;if(!parent)return undefined;
    let previous=parent.scrollTop;
    const scroll=()=>{const top=parent.scrollTop;if(top<40&&previous>=40)void runRef.current();previous=top;};
    parent.addEventListener("scroll",scroll,{passive:true});
    return()=>parent.removeEventListener("scroll",scroll);
  },[hasMore,storeId,phone]);
  return hasMore?<div ref={button} style={{textAlign:"center",padding:8,flexShrink:0}}>
    <button type="button" onClick={run} disabled={busy}>{busy?"Carregando…":"Carregar anteriores"}</button>
    {error&&<div role="alert">{error}</div>}
  </div>:null;
}
